import React from 'react';
import { useSelector } from 'react-redux';
import { BoxWrapper } from './CommonPurchase.styles';
import {
  ActionRow,
  DetailGrid,
  DetailItem,
  DocChip,
  DocChips,
  InfoBoxGrid,
  InfoCard,
  InfoCardHeader,
  InfoCardTitle,
  PrimaryActionButton,
  SectionLabel,
  StatusPill,
} from './InfoBoxV2.styles';
import ProductsTableCard from './ProductsTableCard';
// import { guideType, primaQuoteTypes } from '../../../../constants';
// import MessagesModal from '../../../elements/MessagesModal';
import { downloadFile } from '../../../../../services/axios-client/axeHelpers';
import axe from '../../../../../services/axios-client/axiosClient';
import {
  commercialExtraQuoteTypes,
  getDDFDocument,
  safeCapitalizeWords,
} from '../../../../constants';
import { apiDownloadDocument } from '../../../../../services/axios-client/axeCommons';
import { getBrokeragePerPayment, isNewBrokerageSystem } from '../../../../helpers/brokerageHelpers';

function InfoBoxCommercial({
  insuranceRequest,
  statues,
  quoteStatus,
  // messagesModalData,
  rc_quotation,
  risk_quotations,
}) {
  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  const downloadResourceDocs = async (id) => {
    const res = await axe.get(`/download-resource-document/${id}/0`, {
      responseType: 'blob',
    });

    downloadFile(res.data);
  };

  // const downloadPreventive = async () => {
  //   const res = await axe.get(
  //     `/quotations/${rc_quotation.id}/preventivo/generate`,
  //     {
  //       responseType: 'blob',
  //     },
  //   );

  //   downloadFile(res.data);
  // };

  const downloadPreventive = async () => {
    const res = await axe.get(
      `/quotations/${rc_quotation.id}/preventivo/generate`,
      {
        responseType: 'blob',
      },
    );

    downloadFile(res.data);
  };

  const DDF_document = getDDFDocument(rc_quotation, insuranceRequest);

  const downloadDocument = async (documentId) => {
    if (documentId === undefined) {
      return;
    }
    const response = await apiDownloadDocument(documentId);
    const alink = document.createElement('a');
    alink.target = '_blank';
    alink.href = response.data.data.contents;
    alink.download = response.data.data.filename;
    alink.click();
  };

  const getTotal = () => {
    let rcTotalAmount = 0;
    let risksTotalAmount = 0;

    rcTotalAmount = rc_quotation.amount;

    if (risk_quotations && risk_quotations.length > 0) {
      for (let i = 0; i < risk_quotations.length; i++) {
        const item = risk_quotations[i];

        risksTotalAmount += parseFloat(item.amount);
      }
    }

    return parseFloat(rcTotalAmount + risksTotalAmount + (rc_quotation.amount_paid !== null && !isNewBrokerageSystem(rc_quotation) ? 0 : getBrokeragePerPayment(rc_quotation))).toFixed(2);
  };

  return (
    <>
      <BoxWrapper>
        <InfoBoxGrid>
          <InfoCard className="documents-status-step-one pagament-status-step-one">
            <InfoCardHeader>
              <InfoCardTitle>Riepilogo</InfoCardTitle>
              <StatusPill>{statues.find((st) => st.id === quoteStatus).name}</StatusPill>
            </InfoCardHeader>
            <DetailGrid>
              <DetailItem className="full">
                <dt>Cliente</dt>
                <dd>{insuranceRequest.customer ? (insuranceRequest.customer.business_name ? insuranceRequest.customer.full_business_name : (insuranceRequest.customer.full_name)) : insuranceRequest.commercial_company.business_name}</dd>
              </DetailItem>
              {insuranceRequest?.commercial_company?.company_number && (
                <DetailItem>
                  <dt>Numero Compagnia</dt>
                  <dd>{insuranceRequest?.commercial_company?.company_number ?? '-'}</dd>
                </DetailItem>
              )}
              <DetailItem>
                <dt>Decorrenza</dt>
                <dd>
                  {new Date(
                    insuranceRequest.policy_effective_date,
                  ).toLocaleDateString('it-IT')}
                </dd>
              </DetailItem>
              <DetailItem>
                <dt>Vat number</dt>
                <dd>{insuranceRequest.customer ? insuranceRequest.customer.vat_number : insuranceRequest.commercial_company.vat_number}</dd>
              </DetailItem>
              <DetailItem>
                <dt>Frequenza Pagamento</dt>
                <dd>
                  {insuranceRequest.payment_frequency === 1
                    ? 'Annuale'
                    : 'Semestrale'}
                </dd>
              </DetailItem>
            </DetailGrid>

            <SectionLabel>Documenti</SectionLabel>
            <DocChips>
              {/* <h6
                className="mt-2 text-decoration-underline"
                onClick={() => downloadPreventive()}
                style={{ cursor: 'pointer' }}
              >
                Preventivo
              </h6> */}
              <DocChip type="button" onClick={() => downloadPreventive()}>
                Preventivo
              </DocChip>
              {rc_quotation.company_id == 16 && (
                <DocChip
                  type="button"
                  onClick={() => downloadResourceDocs(12, 0)}
                >
                  Informazioni Precontrattuali
                </DocChip>
              )}
              {rc_quotation.company_id == 1001 && (
                <DocChip
                  type="button"
                  onClick={() => downloadResourceDocs(40, 0)}
                >
                  Informazioni Precontrattuali
                </DocChip>
              )}
              {risk_quotations
                && risk_quotations.find((q) => q.company_id === 16)
                !== undefined && (
                  <DocChip
                    type="button"
                    onClick={() => downloadResourceDocs(13)}
                  >
                    Informazioni Precontrattuali Global Assistance
                  </DocChip>
              )}
              {risk_quotations
                && risk_quotations.find((q) => q.company_id === 8)
                !== undefined && (
                  <DocChip type="button" onClick={() => downloadResourceDocs(14)}>
                    Informazioni Precontrattuali Europe Assistance
                  </DocChip>
              )}
            </DocChips>

            <ActionRow>
              <PrimaryActionButton
                type="button"
                onClick={() => downloadDocument(DDF_document.id)}
              >
                Scarica Documento Da Firmare
              </PrimaryActionButton>
            </ActionRow>
          </InfoCard>

          {/* <th scope="col">Frequenza Pagamento</th> */}
          <ProductsTableCard
            className="documents-status-step-two pagament-status-step-two"
            total={getTotal()}
          >
            <tr>
              <td>{rc_quotation.product.name}</td>
              <td>
                {rc_quotation.company_id !== null
                  && rc_quotation.company.name}
              </td>
              {/* <td>
                {rc_quotation.payment_frequency === 1
                  ? 'Annuale'
                  : 'Semestrale'}
              </td> */}
              <td>
                {parseFloat(rc_quotation.amount - rc_quotation.issuance_fee - (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2)}
                {' '}
                &euro;
              </td>
            </tr>
            {risk_quotations
              && risk_quotations.map((quote, index) => (
                <tr key={index}>
                  <td>
                    {quoteTypes.find(
                      (type) => type.id === quote.quote_type,
                    ) === undefined
                      ? safeCapitalizeWords(commercialExtraQuoteTypes.find(
                        (type) => type.id === quote.quote_type,
                      ).name)
                      : safeCapitalizeWords(quoteTypes.find(
                        (type) => type.id === quote.quote_type,
                      ).name)}
                  </td>
                  <td>{quote.company.name}</td>
                  {/* <td>
                    {quote.payment_frequency === 1
                      ? 'Annuale'
                      : 'Semestrale'}
                  </td> */}
                  <td>
                    {parseFloat(quote.amount).toFixed(2)}
                    {' '}
                    &euro;
                  </td>
                </tr>
              ))}
            <tr>
              <td>
                Brokeraggio
                {rc_quotation.amount_paid !== null && !isNewBrokerageSystem(rc_quotation) && <span className="text-success fw-bold"> (Pagato)</span>}
              </td>
              <td />
              {/* <td>
                {rc_quotation.payment_frequency === 1 || !isNewBrokerageSystem(rc_quotation)
                  ? 'Annuale'
                  : 'Semestrale'}
              </td> */}
              <td>
                {parseFloat(getBrokeragePerPayment(rc_quotation)).toFixed(2)}
                {' '}
                &euro;
              </td>
            </tr>
            <tr>
              <td>Spese Di Emissione</td>
              <td />
              {/* <td>
                {rc_quotation.payment_frequency === 1
                  ? 'Annuale'
                  : 'Semestrale'}
              </td> */}
              <td>
                {rc_quotation.payment_frequency === 1
                  ? parseFloat(parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2)
                  : parseFloat(
                    (parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0))
                    / rc_quotation.payment_frequency,
                  ).toFixed(2)}
                {' '}
                &euro;
              </td>
            </tr>
          </ProductsTableCard>
        </InfoBoxGrid>
      </BoxWrapper>
      {/* <MessagesModal
        {...messagesModalData}
        threads={insuranceRequest.threads}
      /> */}
    </>
  );
}

export default InfoBoxCommercial;
